// Accordion.jsx
import React, {useState, useEffect} from 'react';
import '../styles/components/accordion.css';

const Accordion = ({
                       title,
                       content,
                       isExpanded = false,
                       isChecked = false,
                       onToggle,
                       onCheck,
                       className = ''
                   }) => {
    const [expanded, setExpanded] = useState(isExpanded);
    const [checked, setChecked] = useState(isChecked);

    useEffect(() => {
        setChecked(isChecked);
    }, [isChecked]);

    const handleCheck = () => {
        const newChecked = !checked;
        setChecked(newChecked);
        if (onCheck) onCheck(newChecked);
    };

    const handleToggle = () => {
        const newExpanded = !expanded;
        setExpanded(newExpanded);
        if (onToggle) onToggle(newExpanded);
    };

    return (
        <div className={`accordion-item ${className}`}>
            <div className="accordion-header">
                <div className="accordion-left">
                    <div
                        className={`custom-accordion-checkbox ${checked ? 'checked' : ''}`}
                        onClick={handleCheck}
                    />
                    <span className="accordion-title gmarket-font">{title}</span>
                </div>
                <span className="accordion-toggle-button" onClick={handleToggle}>
                  {expanded ? '접기' : '펼치기'}
                </span>
            </div>


            {expanded && (
                <div className="accordion-box">
                    <h4>{title}</h4>
                    <div dangerouslySetInnerHTML={{__html: content}}/>
                </div>
            )}
        </div>
    );
};

export default Accordion;
